import { PropsWithChildren } from "react";
import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";

import { CommonFieldProps } from "./types";

interface Props<T extends FieldValues> extends CommonFieldProps<T> {
    control: Control<T, any>;
    options: any[];
    labelId: string;
    label: string;
    multiple?: boolean;
}

const FieldSelectList: React.FunctionComponent<Props<any>> = <TObject extends FieldValues>({
    control,
    fieldName,
    options,
    labelId,
    label,
    multiple = false,
    children,
}: PropsWithChildren<Props<TObject>>) => (
    <Controller
        name={fieldName}
        control={control}
        defaultValue={(multiple ? [] : '') as PathValue<TObject, Path<TObject>>}
        render={({ field, fieldState: {error} }) => (
            <FormControl fullWidth margin="normal" error={error !== undefined}>
                <InputLabel id={labelId}>{label}</InputLabel>
                <Select
                    {...field}
                    labelId={labelId}
                    label={label}
                    multiple={multiple}
                    defaultValue={(multiple ? [] : '')}
                >
                    {options.map((val) => (
                        <MenuItem value={Array.isArray(val) ? val[0] : val} key={Array.isArray(val) ? val[0] : val}>
                            {Array.isArray(val) ? val[1] : val}
                        </MenuItem>
                    ))}
                </Select>
                {error && <FormHelperText>{error.message}</FormHelperText>}
                {children}
            </FormControl>
        )}
    />
);

export default FieldSelectList;